<script setup>
// import { reactive } from 'vue';
import { onMounted, onUnmounted, ref, watch } from 'vue';

// // Store management imports
import { useBreakStore } from '@/stores/break';

// // Utils imports
import { CommunicationUtil } from '@samsung360vr/overlay-app-sdk';
import backendApis from '@/utils/backendApis';

// // Asset imports
// import pollBackgroundSrc from '@/assets/images/backgrounds/backdrop-s-poll-question-marks.png';
import TvPLinkerButton from '@/views/TvPlusLinker/TvPLinkerButton.vue';
import tvplus from '@/assets/images/overlays/tv_plus_white_skye_edit.png';

const storeBreak = useBreakStore();

const isKeyCurrentlyPressed = ref(false);
const hasOptionBeenSelected = ref(false);
const activeIndex = ref(0);
const pressedKey = ref('');

// // Poll handler functions

const keyDownHandler = (e) => {
  // console.log(`You pressed ${e.key}: ${e.code}.`);

  CommunicationUtil.onKeyPressed(e.keyCode);
  isKeyCurrentlyPressed.value = true;
  pressedKey.value = e.key;
};

const keyUpHandler = () => {
  // console.log(`You are no longer pressing ${e.key}: ${e.code}.`);

  isKeyCurrentlyPressed.value = false;
  pressedKey.value = '';
};

// const callActiveIndex = () => {
//   return isUnableToPopulate;
// };

const buttonSelectHandler = async () => {
  await backendApis
    // .putPollData(props.breakUuid, props.pollOptions[activeIndex.value].optionLabel)
    .putPollData(storeBreak.breakUuid, storeBreak.breakOptions[activeIndex.value].optionLabel)
    .then(async (capturedJson) => {
      console.log(`backendApis.putPollData() SUCCESS`);
      console.log(`capturedJson:${capturedJson}`);
      if (capturedJson) {
        pollPercentages = calculateResults(capturedJson);
      } else {
        pollPercentages = dummyOutput;
      }
    })
    .catch(async (errorResponse) => {
      console.log(`backendApis.putPollData() FAILURE`);

      console.log(errorResponse);
    });

  hasOptionBeenSelected.value = true;
};

// // Poll functions

const calculateResults = (pollResults) => {
  console.log(pollResults);
  const data = pollResults[0];
  const options = Object.values(PollOptions);
  let total = 0;
  const percentageArray = [];
  const resultsArray = options.map((option) => (data[option] === '' ? 0 : Number(data[option])));
  resultsArray.map((result) => (total += result));
  console.log(`Results array: ${resultsArray}`);
  console.log(`total: ${total}`);
  for (const amountIndex in resultsArray) {
    const percentage = calculateVotePercentage(resultsArray[amountIndex], total);
    percentageArray.push(Math.round(percentage));
  }
  console.log(`Percentage array: ${percentageArray}`);
  return percentageArray;
};

const calculateVotePercentage = (currentOptionParam, totalValueParam) => {
  // Number(str)
  return (100 * currentOptionParam) / totalValueParam;
};

// // Poll lifecycle hooks

onMounted(() => {
  document.addEventListener('keydown', keyDownHandler);
  document.addEventListener('keyup', keyUpHandler);
});

onUnmounted(() => {
  document.removeEventListener('keydown', keyDownHandler);
  document.removeEventListener('keyup', keyUpHandler);
});

// // Poll watchers

watch(isKeyCurrentlyPressed, (isKeyCurrentlyPressedNewVal) => {
  if (isKeyCurrentlyPressedNewVal) {
    // console.log('Key is pressed down');
    // console.log(`pressedKey.value: ${pressedKey.value}`);

    if (!hasOptionBeenSelected.value) {
      if (pressedKey.value === 'ArrowDown') {
        // if (activeIndex.value < props.pollOptions.length - 1) {
        if (activeIndex.value < storeBreak.breakOptions.length - 1) {
          activeIndex.value++;
        }
      } else if (pressedKey.value === 'ArrowUp') {
        if (activeIndex.value > 0) {
          activeIndex.value--;
        }
      } else if (pressedKey.value === 'Enter') {
        // console.log(`Button Selected – optionLabel: ${props.pollOptions[activeIndex.value].optionLabel}`);
        console.log(
          `Button Selected – optionLabel: ${storeBreak.breakOptions[activeIndex.value].optionLabel}`,
        );
        // emit('buttonSelected', e);

        buttonSelectHandler();
      }
    }
  }
});
</script>

<template>
  <div class="watch-now-column">
    <!-- <img class="scrim" :src="backgroundScrimUpperRightSrc"> -->
    <div class="watch-now-top">
      <div>Dodgeball: A True Underdog Story</div>
    </div>
    <div class="watch-now-bottom">
      <TvPLinkerButton />
      <img :src="tvplus" class="logo" />
    </div>
  </div>
</template>
